import AddPrinterProvider from '@/features/settings/contexts/AddPrinter'
import { Stack } from 'expo-router'
import { FC } from 'react'

const PrintersLayout: FC = () => (
    <AddPrinterProvider>
        <Stack screenOptions={{ headerShown: false }}>
            <Stack.Screen name="index" />
            <Stack.Screen name="new" />
            <Stack.Screen name="edit/[id]" />
        </Stack>
    </AddPrinterProvider>
)

export default PrintersLayout
